import { render } from "./GithubLogoIcon.vue?vue&type=template&id=46eb0bd7"
import script from "./GithubLogoIcon.vue?vue&type=script&lang=js"
export * from "./GithubLogoIcon.vue?vue&type=script&lang=js"

import "./GithubLogoIcon.vue?vue&type=style&index=0&id=46eb0bd7&lang=scss"

import exportComponent from "/home/runner/work/flydata-next/flydata-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__